import * as VueGoogleMaps from 'gmap-vue';
import GmapCluster from 'gmap-vue/dist/components/cluster';
import Vue from 'vue';

const gmapKeys = {
  prod: 'AIzaSyD3ALP-cPdLXnhjNB7QKG7wQ19cK-6_jMg',
  dev: 'AIzaSyB350JBJeCmAWEedoMT6mL2s7UolvnusZ0',
};

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.NODE_ENV === 'production' ? gmapKeys.prod : gmapKeys.dev,
  },
});
Vue.component('GmapCluster', VueGoogleMaps.Cluster);
Vue.component('GmapCluster', GmapCluster);
